import React, { Component } from 'react';
//import {Alert} from 'react-bootstrap';
import { Table, Jumbotron, Button, Form } from 'react-bootstrap';
//import {Toast} from 'react-bootstrap';
import Menu from '../menu';
import  config from '../../config';
//import funciones from '../../middleware/funciones';
//import { Header } from 'react-bootstrap/lib/Modal';

class Clientes extends Component {
    constructor(props) {
        const currentCompany = sessionStorage.getItem('company');
        const currentUserType = sessionStorage.getItem('tipo');
        super(props);
        this.state = {
            data: [],
            empresa : currentCompany,
            tipo : currentUserType,
            busqueda: ""
        };
    }
    componentDidMount() {
        const datasend = {
            method: 'GET',

            headers: {
                'Content-Type': 'application/json',
                'empresa' : this.state.empresa,
                'tipo' : this.state.tipo,
            }
        }
        fetch(config.servBackEnd+'/clients/', datasend).then(response => response.json())
            .then(data => this.setState({ data }));
    }

    render() {
        const dato = (this.state.data) ? this.state.data : [];
        const {busqueda} = this.state;
        const style = {
            color: "white",
            backgroundColor: "DodgerBlue",
            padding: "10px",
            fontFamily: "Arial"
        };

        return (

            <div className="contenedor">
                <Menu></Menu>
                <Jumbotron style={style}>
                    <h1>Modulo Clientes</h1>
                </Jumbotron>
                <Button className="plus" size="sm" href="/clientes/crear/" variant="outline-primary">Crear Cliente</Button>
                <Form.Control className="mb-2 mr-sm-2"  id="busquedaCLiente" placeholder="Nit o Nombre" onChange={(e)=>this.setState({busqueda: e.target.value})}  value={busqueda}/>
                <Table hover bordered responsive size="sm" className="table">
                    <thead>
                        <tr>
                            <th>EMPRESA</th>
                            <th>CODIGO</th>
                            <th>NOMBRE</th>
                            <th>ESTABLECIMIENTO</th>
                        </tr>
                    </thead>
                    <tbody>
                        {dato.map(function (currentData, index) {
                            if(currentData.DOCUMENTO_CLIENTE.toLowerCase().search(busqueda.toLowerCase()) > -1
                            || currentData.NOMBRE_CLIENTE.toLowerCase().search(busqueda.toLowerCase()) > -1 
                            || currentData.NOMBRE_ESTABLECIMIENTO.toLowerCase().search(busqueda.toLowerCase()) > -1 ){
                            return <tr key={index + "d0"}>
                                <td key={index + "d1"}>{currentData.ID_EMPRESA}</td>
                                <td key={index + "d2"}>{currentData.DOCUMENTO_CLIENTE}</td>
                                <td key={index + "d3"}>{currentData.NOMBRE_CLIENTE}</td>
                                <td key={index + "d4"}>{currentData.NOMBRE_ESTABLECIMIENTO}</td>
                                <td key={index + "d6"}><Button size="sm" href={"/clientes/crear/?"+currentData.ID_CLIENTES} variant="outline-primary">Editar</Button></td>
                            </tr>;
                            }else{
                                return null;
                            }
                        })}
                    </tbody>
                </Table>
            </div>
        );
    }
}
export default (Clientes);